import React, { useEffect, useState } from "react";
import { request } from "../../../utils/request";
import { catalogoUnidades } from "../../../utils/unidades";
import Select from 'react-select';

const Form = ({insumo, setInsumo, setEsValido, errors, saving}) => {
    const [impuestos, setImpuestos] = useState([]);
    const [unidades, setUnidades] = useState([]);

    const getUnidades = async () => {
        setUnidades(await catalogoUnidades());
    };

    const getImpuestos = async () => {
		const impuestos = await request("impuestos-dropdown");

		setImpuestos(impuestos.success ? impuestos.data : []);
	};

    const setProp = (prop, value) => {
        setInsumo({
            ...insumo,
            [prop]: value,
        });
    };

    useEffect(() => {
        let costo_total = 0;

        if (insumo.impuesto && insumo.costo) {
            costo_total = ((parseFloat(insumo.costo) * (1 + insumo.impuesto.porcentaje)).toFixed(2));
        }

        setProp('costo_total', costo_total);
    }, [insumo.costo, insumo.impuesto]);

    useEffect(() => {
        if (!insumo.tipo || !insumo.nombre || !insumo.unidad || !insumo.referencia
         || !insumo.costo || !insumo.impuesto) {
            setEsValido(false);
            return;
        }

        setEsValido(true);
    }, [insumo]);

    useEffect(() => {
        getImpuestos();
        getUnidades();
    }, []);

    return <div className="items">
        <div className="row">
            <div className="col-12 col-md-6">
                <div className="form-group">
                    <label className="label form-control-label">Tipo*:</label>

                    <select
                        className="form-control"
                        name="tipo"
                        value={insumo.tipo}
                        onChange={e => setProp("tipo", e.target.value)}
                        disabled={saving}
                    >
                        <option value="">Seleccionar...</option>
                        <option value="Medicamento">Medicamento</option>
                        <option value="Artículo">Artículo</option>
                    </select>

                    {errors.tipo && (
                        <small className="help-blockParams form-Text">
                            {errors.tipo[0]}
                        </small>
                    )}
                </div>

                <div className="form-group">
                    <label className="label form-control-label">Nombre*:</label>
                    <input
                        type="text"
                        className="text-input form-control"
                        id="nombre"
                        name="nombre"
                        value={insumo.nombre}
                        onChange={e => setProp("nombre", e.target.value)}
                        disabled={saving}
                    />
                    {errors.nombre && (
                        <small className="help-blockParams form-Text">
                            {errors.nombre[0]}
                        </small>
                    )}
                </div>

                <div className="form-group">
                    <label className="label form-control-label">Referencia*:</label>
                    <input
                        type="text"
                        className="text-input form-control"
                        id="referencia"
                        name="referencia"
                        value={insumo.referencia}
                        onChange={e => setProp("referencia", e.target.value)}
                        disabled={saving}
                    />
                    {errors.referencia && (
                        <small className="help-blockParams form-Text">
                            {errors.referencia[0]}
                        </small>
                    )}
                </div>

                <div className="form-group">
                    <div className="row">
                        <div className="col">
                            <label className="label form-control-label">Costo*:</label>

                            <input
                                type="number"
                                className="text-input form-control"
                                id="costo"
                                name="costo"
                                step="0.01"
                                value={insumo.costo}
                                onChange={(e) => setProp("costo", e.target.value)}
                                disabled={saving}
                            />

                            {errors.costo && (
                                <small className="help-blockParams form-Text">
                                    {errors.costo[0]}
                                </small>
                            )}
                        </div>

                        <div className="p-t-15" style={{width: "auto"}}>
                            <span className="h2 color-primary">+</span>
                        </div>

                        <div className="col">
                            <label className="label form-control-label">Impuesto*:</label>

                            <Select
                                name="impuesto"
                                isClearable
                                cacheOptions
                                placeholder="Seleccionar..."
                                value={insumo.impuesto}
                                onChange={e => setProp('impuesto', e ?? null)}
                                options={impuestos}
                                isDisabled={saving}
                                
                            />
                        </div>

                        <div className="p-t-15" style={{width: "auto"}}>
                            <span className="h2 color-primary">=</span>
                        </div>

                        <div className="col">
                            <label className="label form-control-label">Costo Total:</label>

                            <input
                                type="number"
                                className="text-input form-control"
                                id="costo_total"
                                name="costo_total"
                                step="0.01"
                                min="0"
                                value={insumo.costo_total}
                                readOnly
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-12 col-md-6">
                <div className="form-group row">
                    <div className="col-md-6">
                        <label className="label form-control-label">Cantidad*:</label>

                        <input
                            type="number"
                            className="text-input form-control"
                            id="cantidad"
                            name="cantidad"
                            step="0.01"
                            value={insumo.cantidad}
                            onChange={e => setProp("cantidad", e.target.value)}
                            disabled={saving}
                        />

                        {errors.cantidad && (
                            <small className="help-blockParams form-Text">
                                {errors.cantidad[0]}
                            </small>
                        )}
                    </div>
                    
                    <div className="col-md-6">
                        <label className="label form-control-label">Unidad*:</label>

                        <select
                            className="form-control"
                            name="unidad"
                            value={insumo.unidad}
                            onChange={e => setProp("unidad", e.target.value)}
                            disabled={saving}
                        >
                            <option value="">Seleccionar...</option>
                            {unidades.map(unidad => <option key={unidad.value} value={unidad.value}>{unidad.label}</option>)}
                        </select>

                        {errors.unidad && (
                            <small className="help-blockParams form-Text">
                                {errors.unidad[0]}
                            </small>
                        )}
                    </div>
                </div>

                <div className="form-group">
                    <label className="label form-control-label">Descripción:</label>

                    <textarea
                        className="text-input form-control"
                        id="descripcion"
                        name="descripcion"
                        rows="7"
                        value={insumo.descripcion}
                        onChange={e => setProp("descripcion", e.target.value)}
                        disabled={saving}
                    />
                    {errors.descripcion && (
                        <small className="help-blockParams form-Text">
                            {errors.descripcion[0]}
                        </small>
                    )}
                </div>
            </div>
        </div>
    </div>;
};

export default Form;
